import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '@/lib/apiClient'

export type SingleChoice = 'yes' | 'no' | 'prefer_not_to_say'
export type BraceletStatus = 'requested' | 'distributed' | 'returned' | 'cancelled'

export interface MySinglePreference {
  attendee_id: string
  choice: SingleChoice
  source: 'checkout' | 'profile' | 'checkin' | 'admin'
  updated_at: string | null
  /** Le dispositif existe-t-il pour cette édition ? */
  enabled: boolean
  bracelet_status: BraceletStatus | null
  /** Vrai une fois entré : le choix se fige. */
  locked: boolean
}

function query(token: string, attendeeId: string): string {
  return `token=${encodeURIComponent(token)}&attendee_id=${encodeURIComponent(attendeeId)}`
}

/**
 * RULE 7 — ce hook appelle le seul endpoint du système qui renvoie le choix
 * lui-même, et il exige le lien de commande de la personne concernée.
 */
export function useSinglePreference(token: string | null, attendeeId: string | null) {
  return useQuery({
    queryKey: ['single-preference', token, attendeeId],
    queryFn: () =>
      apiClient.get<MySinglePreference>(
        `/me/single-preference?${query(token ?? '', attendeeId ?? '')}`,
      ),
    enabled: Boolean(token && attendeeId),
  })
}

export function useSetSinglePreference(token: string | null, attendeeId: string | null) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (choice: SingleChoice) =>
      apiClient.put<MySinglePreference>(
        `/me/single-preference?${query(token ?? '', attendeeId ?? '')}`,
        { choice },
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['single-preference', token, attendeeId] })
    },
  })
}
